import { defGetter } from "./getter.js";
import { defSetter } from "./setter.js";
const updateInUnsafe = (state, path, fn, ...args) => (
  // @ts-ignore
  updateIn(state, path, fn, ...args)
);
function updateIn(state, path, fn, ...args) {
  return defSetter(path)(
    state,
    // @ts-ignore
    fn.apply(null, (args.unshift(defGetter(path)(state)), args))
  );
}
export {
  updateIn,
  updateInUnsafe
};
